import { Link } from 'react-router-dom';
import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20luxurious%20dark%20background%20with%20flowing%20golden%20ribbons%20and%20warm%20ambient%20light%20particles%2C%20elegant%20and%20sophisticated%20composition%2C%20deep%20burgundy%20and%20gold%20color%20scheme%2C%20subtle%20geometric%20patterns%2C%20premium%20atmospheric%20render%2C%20no%20text%20or%20people&width=1920&height=800&seq=hero-bg-main-01&orientation=landscape"
        alt="博彩网 - 专业博彩平台导航与资讯中心"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-5">
            专业博彩平台导航
            <br />
            与<span className="text-accent-400">资讯</span>中心
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            博彩网是您最值得信赖的专业博彩资讯平台，提供最新博彩网站评测、优惠活动、
            赔率分析及安全指南。帮助用户找到正规可靠的博彩平台，享受安全娱乐体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link
              to="/category/pingce"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-md text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
            >
              查看平台评测
            </Link>
            <Link
              to="/category/youhui"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md text-base font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
            >
              最新优惠活动
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {heroStats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-400 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-200/70">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}